import { Component, OnInit, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonEmailField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-email-field',
	imports: [FormsModule],
	templateUrl: './common-email-field.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonEmailFieldWidget extends CommonFieldWidgetBase<string, CommonEmailField> implements OnInit {

	public readonly field = input.required<CommonEmailField>();

	public readonly labels = computed(() => getLabels(this.field().config().isSpanish));


	public readonly renderedModel = computed(() => {
		const value = this.field().pendingValue() ?? this.field().actualValue();
		return this.render(value);
	});


	private emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: string) {
		this.processChange(value);
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected override cleanValue(value: string) {
		return value.trim().toLowerCase();
	}


	protected validate(value: string): string {

		const config = this.field().config();
		const labels = this.labels();

		if (value.length == 0 && config.isRequired) return labels.missingRequired();
		if (value.length && !value.match(this.emailPattern)) return labels.notValidEmail();

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}
}